<template>
         <el-dialog :visible.sync="csDetailDialog" width="48%" top="5vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card style="height: 550px">
            <el-tabs v-model="card" type="card" @tab-click="chooseTabs">
            <el-tab-pane label="代理信息" name="1">
                <el-form label-width="85px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="10"><el-form-item label="代理编号"><span>{{response.csInfo.csCode}}</span></el-form-item></el-col>
                        <el-col :span="10"><el-form-item label="代理类型"><span >{{response.csInfo.typeStr}}</span></el-form-item></el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10"><el-form-item label="代理名称"><span>{{response.csInfo.subjectName}}</span></el-form-item></el-col>
                        <el-col :span="10"><el-form-item label="联系方式"><span >{{response.csInfo.phone}}</span></el-form-item></el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item label="是否分润">
                                <span v-if="response.csInfo.delFlag === '1'">是</span>
                                <span v-else>否</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="分润比例">
                                <span v-if="response.csInfo.delFlag === '1'">{{response.csInfo.reward}}</span>
                                <span v-else>0</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-form-item label="账号状态">
                                <span v-if="response.csInfo.delFlag === '0'">正常</span>
                                <span v-else>冻结</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="账号操作">
                                <el-button v-if="response.csInfo.delFlag === '0'" @click="operationAccount"> 冻结</el-button>
                                <el-button v-else @click="operationAccount"> 解冻</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="商户信息" name="2">
                <el-row :gutter="20">
                        <el-col :span="6">
                            <el-input v-model="bsRequest.bsName" placeholder="商户姓名" style="width:200px" clearable></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-input v-model="bsRequest.bsPhone" placeholder="商户电话" style="width:200px" clearable></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getBsList()">搜索</el-button>
                        </el-col>
                    </el-row>
                <el-table :data="response.bsList" style="width: 100%" height="400" border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                    <el-table-column label="商户名称" align="center" prop="name"></el-table-column>
                    <el-table-column label="商户电话" align="center" prop="phone"></el-table-column>
                    <el-table-column label="是否分润" align="center" prop="rewardFlag"></el-table-column>
                    <el-table-column label="分润比例" align="center" prop="rewardPercent"></el-table-column>
                    <el-table-column label="摊销比例" align="center" prop="txPercent"></el-table-column>
                    <el-table-column label="门店数量" align="center" prop="storeNum"></el-table-column>
                </el-table>
                <el-pagination :current-page="query.current" :total="response.total" @current-change="bsCurrenChangeHandle" layout="total, prev, pager, next, jumper"/>
            </el-tab-pane>
            <el-tab-pane label="BD信息" name="3">
                <el-table :data="response.csInfo.bdInfo" style="width: 100%" height="430" border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                    <el-table-column label="BD编号" align="center" prop="code" width="150"></el-table-column>
                    <el-table-column label="BD类型" align="center" prop="type"></el-table-column>
                    <el-table-column label="BD职位" align="center" prop="org"></el-table-column>
                    <el-table-column label="BD名称" align="center" prop="bdName"></el-table-column>
                    <el-table-column label="BD电话" align="center" prop="bdPhone"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="门店信息" name="4">
                <el-table :data="response.storeInfo" style="width: 100%" height="430" border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                    <el-table-column label="门店编号" align="center" prop="code" width="150"></el-table-column>
                    <el-table-column label="门店名称" align="center" prop="name"></el-table-column>
                    <el-table-column label="门店单价" align="center">
                        <template slot-scope="scope">{{scope.row.unitPrice / 100}}元/{{scope.row.sku}}分钟 </template>
                    </el-table-column>
                    <el-table-column label="联系人" align="center" prop="contactName"></el-table-column>
                    <el-table-column label="联系方式" align="center" prop="contactPhone"></el-table-column>
                </el-table>
                <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper"/>
            </el-tab-pane>
            <el-tab-pane label="设备申领记录" name="5">
                <el-table :data="response.csInfo.applyRecord" style="width: 100%" height="430" border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                    <el-table-column label="申请ID" align="center" prop="applyId" width="150"></el-table-column>
                    <el-table-column label="申请类型" align="center" prop="typeStr"></el-table-column>
                    <el-table-column label="申请数量" align="center" prop="num"></el-table-column>
                    <el-table-column label="申请时间" align="center">
                        <template slot-scope="scope">{{scope.row.createTime | formatDate}}</template>
                    </el-table-column>
                    <el-table-column label="申请状态" align="center" prop="stateStr"></el-table-column>
                </el-table>
            </el-tab-pane>
            </el-tabs>
        </el-card>
    </el-dialog>
</template>
<script>
import {getCsInfoById, getCsStoreInfo, operationAccount, getBsByCsId} from '../../api/relation/csrelation.js'
import { formatDate } from "../../utils/date";
export default {
    data() {
        return {
            csDetailDialog: false,
            loading: false,
            card: "1",
            bsRequest: {
                csId: '',
                bsName: '',
                bsPhone: '',
                current: '',
                size: ''
            },
            response: {csInfo: '',storeInfo: [], bsList: [], total: 0},
            query: {current: 1, size: 10}
        }
    },
    methods: {
        init(value) {
            this.csDetailDialog = true;
            getCsInfoById(value).then(result=>{
                this.response.csInfo = result.data;
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.csDetailDialog = false;
            this.card = "1";
            this.response.csInfo = '';
            this.response.storeInfo = [];
        },

        /**
         * 操作账号
         */
        operationAccount(){
            operationAccount({identity: "cs",id: this.response.csInfo.csId,state: this.response.csInfo.delFlag === '0' ? '1' : '0'})
            .then(result=>{
                this.$confirm('操作成功', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success',
                center: true
            }).then(() => {
                getCsInfoById(this.response.csInfo.csId).then(result=>{
                    this.response.csInfo = result.data;
                })
            }).catch(()=>{
            })
        })
        },

        /**
         * 卡片选择
         */
        chooseTabs(value){
            this.response.storeInfo = [];
            this.response.bsList = [];
            this.query.current = 1;
            this.query.size = 10;
            if(value.name === "2"){
                this.bsRequest.csId = this.response.csInfo.csId;
                this.bsRequest.current = this.query.current;
                this.bsRequest.size = this.query.size;
                getBsByCsId(this.bsRequest).then(result=>{
                    this.response.bsList = result.data.records;
                    this.response.total = result.data.total;
                })
            }
            if(value.name === "4"){
                getCsStoreInfo(this.response.csInfo.csId,{current: this.query.current, size: this.query.size}).then(result=>{
                    this.response.storeInfo = result.data.records;
                    this.response.total = result.data.total;
                })
            }
        },
        /**
         * 页码改变
         */
        currenChangeHandle(value){
            getCsStoreInfo(this.response.csInfo.csId,{current: value, size: this.query.size}).then(result=>{
                this.response.storeInfo = result.data.records;
                this.response.total = result.data.total;
            })
        },

        /**
         * 页码改变
         */
        bsCurrenChangeHandle(value){
            this.response.bsList = [];
            this.query.current = value;
            this.query.size = 10;
            this.bsRequest.csId = this.response.csInfo.csId;
            this.bsRequest.current = this.query.current;
            this.bsRequest.size = this.query.size;
            getBsByCsId(this.bsRequest).then(result=>{
                this.response.bsList = result.data.records;
                this.response.total = result.data.total;
            })
        },

        /**
         * 搜索商户
         */
        getBsList(){
            this.bsRequest.csId = this.response.csInfo.csId;
            this.bsRequest.current = this.query.current;
            this.bsRequest.size = this.query.size;
            getBsByCsId(this.bsRequest).then(result=>{
                this.response.bsList = result.data.records;
                this.response.total = result.data.total;
            })
        }
        
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  }
}
</script>
<style scoped>
.el-pagination{
    margin-left: 15%;
}
</style>>


// WEBPACK FOOTER //
// src/pages/relation/csDetail.vue